















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import { CONTRACTS, WindowsServiceContract } from '@/core/contracts';
import { Table, TableConfig } from './types';
import SaveForTypeOption from './SaveForTypeOption.vue';
import App from '@/App.vue';

@Component({
    components: {
        SaveForTypeOption,
    },
})
export default class TableOptions extends Vue {
    @Prop() public table?: Table;
    @Prop(String) public tableKey!: string;

    @Inject(CONTRACTS.WindowsService)
    public windowsService?: WindowsServiceContract;

    public showPopupDialog: boolean = false;

    public updated() {
        Vue.set(this.tableOption, 'haveFilters', this.tableOption.haveFilters);
    }

    public get tableOption(): TableConfig {
        const { table } = this;
        return table ? table.option() : {};
    }

    public resetFilters() {
        this.table!.clearFilter();
    }

    public exportToExcel() {
        const {
            tableOption: { export: exporting },
            table,
        } = this;
        if (exporting && exporting.enabled) {
            table!.exportToExcel(false);
        }
    }

    public setupTableGroups() {
        // the only way to hide group panel is to hide DOM element
        // because with disabled group panel DX will not load groups from stored layout.
        const instance = this.table;
        const gridElement = (instance as any)._$element[0] as HTMLElement;
        const headerPanelElement = gridElement!.querySelector(
            '.dx-datagrid-header-panel'
        ) as HTMLElement;
        const toolbarItemElement = headerPanelElement!.querySelector(
            '.dx-toolbar-item-content'
        ) as HTMLElement;
        const style = window.getComputedStyle(headerPanelElement);
        headerPanelElement.style.display =
            style.display === 'none' ? 'inherit' : 'none';
        toolbarItemElement.style.lineHeight = 'normal';
    }

    public setupTableColumns() {
        const {
            tableOption: { columnChooser },
            table,
        } = this;
        if (columnChooser && columnChooser.enabled) {
            table!.showColumnChooser();
        }
    }

    public resetTableLayout() {
        const { windowsService, table, $options } = this;
        const { l: localizeFilter } = $options.filters!;

        windowsService!
            .showDialog(localizeFilter('ResetTableSettingsDialog'), [
                { id: 1, caption: localizeFilter('DialogYes') },
                { id: 2, caption: localizeFilter('DialogCancel') },
            ])
            .then(id => {
                if (id === 1 && table) {
                    table.state({});
                    table.repaint();
                    table.refresh();
                }
            });
    }
}
